export default __webpack_public_path__ + "static/media/facebook.daea2043.png";